import {getDefinedUrlSearchParams} from '@lib/util'
import {fetch} from '@lib/fetch'

function checkQuestionnaireEnvironmentAndFetch(url, options) {
  let allowFetch = true
  if (allowFetch) {
    return fetch(url, options)
  } else {
    return Promise.resolve(null)
  }
}

export function questionnairesGet(queryParams) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function questionnaireGet(id) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms/${id}`, {
    method: 'GET',
  })
}

export function questionnaireBulkArchive(body) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms/bulk-archive`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function questionnaireUnArchive(id, body) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function questionnaireCreate(body) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function questionnaireAddCompanies(assessmentId, companyIds) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms/${assessmentId}/add-companies`, {
    method: 'POST',
    body: JSON.stringify(companyIds),
  })
}

export function questionnaireCompaniesGet(id, queryParams) {
  return checkQuestionnaireEnvironmentAndFetch(
    `/assessment-forms/${id}/companies?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    }
  )
}

export function QuestionnaireFormQuestionTemplatesGet() {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms/question-templates`, {
    method: 'GET',
  })
}

export function questionnaireSubmit(id, questionnaire) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms/${id}`, {
    method: 'PUT',
    body: JSON.stringify(questionnaire),
  })
}

export function questionnaireRequestGet(id) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-form-requests/${id}`, {
    method: 'GET',
  })
}

export function questionnaireAnswerGetById(assessmentForm, questionId) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-form-requests/${assessmentForm}/question/${questionId}`, {
    method: 'GET',
  })
}

export function questionnaireAnswer({assessmentFormQuestionId, options = []}) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-form-requests/answer-question`, {
    method: 'POST',
    body: JSON.stringify({
      assessmentFormQuestionId,
      options,
    }),
  })
}

export function questionnaireApproveQuestionAnswer({assessmentFormId, assessmentFormQuestionId, requestCompanyId}) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms/approve-question-answer`, {
    method: 'POST',
    body: JSON.stringify({assessmentFormId, assessmentFormQuestionId, requestCompanyId}),
  })
}
export function questionnaireDenyQuestionAnswer({assessmentFormId, assessmentFormQuestionId, requestCompanyId}) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms/deny-question-answer`, {
    method: 'POST',
    body: JSON.stringify({assessmentFormId, assessmentFormQuestionId, requestCompanyId}),
  })
}

export function questionnaireFormQuestionCommentsGet(assessmentFormQuestionId, requestCompanyId, markAsRead = false) {
  return checkQuestionnaireEnvironmentAndFetch(
    `/assessment-forms/list-question-comments?assessmentFormQuestionId=${assessmentFormQuestionId}&requestCompanyId=${requestCompanyId}&markAsRead=${markAsRead}`,
    {
      method: 'GET',
    }
  )
}

export function questionnaireFormQuestionCommentAdd({
  assessmentFormQuestionId,
  content,
  requestCompanyId,
  repliedCommentId,
}) {
  return checkQuestionnaireEnvironmentAndFetch('/assessment-forms/add-question-comment', {
    method: 'POST',
    body: JSON.stringify({assessmentFormQuestionId, content, requestCompanyId, repliedCommentId}),
  })
}

export function questionnaireCompanyGet(id, companyId, withoutOptions) {
  return checkQuestionnaireEnvironmentAndFetch(
    `/assessment-forms/${id}/company/${companyId}?withoutOptions=${!!withoutOptions}`,
    {
      method: 'GET',
    }
  )
}

export function questionnaireQuestionGet(id, companyId, questionId) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-forms/${id}/company/${companyId}/questions/${questionId}`, {
    method: 'GET',
  })
}

export function questionnaireRequestPatchByCompanyIds(assessmentId, body) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-form-requests/${assessmentId}/bulk-patch`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function questionnaireRequestPatchByCompanyId(assessmentId, companyId, body) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-form-requests/${assessmentId}/${companyId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function questionnaireGetListExistingLink(id, queryParams) {
  return checkQuestionnaireEnvironmentAndFetch(
    `/assessment-forms/${id}/list-existing-assets?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    }
  )
}

export function getListExistingLink(companyId, queryParams) {
  return fetch(`/questionnaire/${companyId}/list-existing-assets?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function questionnaireRequestsGet(queryParams) {
  return checkQuestionnaireEnvironmentAndFetch(`/assessment-form-requests?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function questionnaireGetProgressSummary(id) {
  return fetch(`/v1/questionnaire/${id}/stats`, {
    method: 'GET',
  })
}

export function questionnaireGetProgressByCompany(id, queryParams) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const data = {
        meta: {
          count: 19,
          pageSize: 50,
          page: 0,
          totalCount: 19,
        },
        data: [
          {
            companyId: 'IP558RH52BI',
            requestCompanyId: 'U39Q21S2WUS',
            assessmentFormId: '1N7Y0NWQDTTGXF8WM9',
            completion: {
              totalQuestions: 2,
              totalAnswered: 2,
              totalMissing: 0,
              totalApproved: 0,
              totalInReview: 2,
              totalDenied: 0,
              inReviewPercentage: 100,
              approvedPercentage: 0,
              deniedPercentage: 0,
              missingPercentage: 0,
            },
            questionnaireDueDate: '2023-03-02T10:44:34.225Z',
            updatedAt: '2023-03-02T10:44:34.225Z',
            updatedByImpersonateId: 'V884MX9NGT2',
            updatedByUserId: 'W8BZ6LRQWAS',
            updatedByUserName: 'Anna trips',
            updatedByCompanyId: 'IP558RH52BI',
            updatedByCompanyName: 'TUM',
            assessmentFormIsArchived: 0,
            assessmentFormName: 'test doc mngt',
            requestCompanyName: 'Fabulous Farmers',
            requestCompanyCountryName: 'India',
            requestCompanyFacilityProcesses: 'FARM',
            requestCompanyFeaturedImageFileUrl:
              'https://retraced-bucket-staging-public.imgix.net/GQP8HWWBNCMQPRFJ5S.png',
            commentCount: 0,
            lastUpdate: [
              {
                type: 'assessment_form',
                updatedAt: '2023-03-02T10:44:34.225Z',
                updatedByUserName: 'Anna trips',
                updatedByCompanyName: 'TUM',
              },
              {
                type: 'assessment_form_questions',
                updatedAt: '2023-03-02T10:44:22.246Z',
                updatedByUserName: 'Anna trips',
                updatedByCompanyName: 'TUM',
              },
              {
                type: 'assessment_form_question_answers',
                updatedAt: '2023-03-02T10:47:03.894Z',
                updatedByUserName: 'Fabulous Farmers',
                updatedByCompanyName: 'Anna trips',
              },
            ],
            totalQuestions: 2,
            totalAnswered: 2,
            totalMissing: 0,
            totalApproved: 0,
            totalInReview: 2,
            totalDenied: 0,
            inReviewPercentage: 100,
            approvedPercentage: 0,
            deniedPercentage: 0,
            missingPercentage: 0,
            totalUsersCount: 4,
            activeUsersCount: 4,
            invitedUsersCount: 0,
            state: 'OPEN',
            lastReminded: new Date().toISOString(),
            supplierCompanyId: 'IP558RH52BI',
            supplierName: 'TUM',
          },
        ],
      }

      resolve(data)
    }, 500)
  })
}

export function questionnaireNotifyReminder(companyIds) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('sent')
    }, 50)
  })
}

export function questionnaireRequestUpdateState(questionnaireId, action) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('sent')
    }, 50)
  })
}

export function syncAllResponses(questionIds) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('sent')
    }, 50)
  })
}

export function updateQuestionnaireWithProfileData(questionnaireId) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({questionsUpdated: 20})
    }, 50)
  })
}
